export interface MapAddressParts {
  restaurant_name: string;
  address: string;
  city_name: string;
  state: string;
  zip_code: string;
}

const MAPS_BASE = 'https://www.google.com/maps/search/?api=1&query=';

/**
 * Compose a Google Maps "search by query" URL from establishment parts.
 *
 * The Google Maps URL contract is `?api=1&query=<URL-encoded text>`. We join
 * the business name, address line, city, and state+zip with commas (the
 * conventional US mailing-address separator) and URL-encode the result.
 * Including the business name lets Google's query parser pin the exact
 * storefront when the name matches a Place; when it does not match (legacy
 * inspection-room labels like "TI STARBUCKS 1 INSIDE BACK"), Google falls back
 * to the geocoded address. Blank parts are skipped so we don't end up with
 * stray commas.
 */
export function buildMapUrl(parts: MapAddressParts): string {
  const name = parts.restaurant_name.trim();
  const street = parts.address.trim();
  const city = parts.city_name.trim();
  const state = parts.state.trim();
  const zip = parts.zip_code.trim();
  const stateZip = [state, zip].filter((p) => p !== '').join(' ');

  const segments = [name, street, city, stateZip].filter((p) => p !== '');
  const query = segments.join(', ');

  // URLSearchParams encodes spaces as '+' which Maps accepts; encodeURIComponent
  // would render '%20' instead. Either works, but '+' keeps URLs more readable
  // in logs and matches the shape Google's own share links produce.
  return MAPS_BASE + new URLSearchParams({ q: query }).toString().slice(2);
}
